import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const ChallengePopup = new PopupBuilder('Challenge', {
  incident_id: Basketball3x3IncidentId.Challenge,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
